import { type FC } from 'react';

import { BaseOfferStep } from './BaseOfferStep';
import { useOfferStepLogic } from './useOfferStepLogic';
import { getOffer } from '../../../shared/helpers';
import { OfferCard } from '../../experiments/exp-n-575/components/OfferCard_B';
import { RibbonHeightSyncProvider } from '../../experiments/exp-n-575/components/useRibbonHeightSync';
import { TitleHeightSyncProvider } from '../../experiments/exp-n-575/components/useTitleHeightSync';
import { useDefaultContractTypePreSelection } from '../../experiments/exp-n-611/hooks/useDefaultContractTypePreSelection';
import { useTouOffersConfig } from '../../experiments/exp-n-657/hooks/useTouOffersConfig';

export const OfferStep: FC = () => {
  // exp-n-657 — Time of Use filtering. Visitors from the exclusion landing page get every offer.
  // Delete this call (and the exp-n-657 folder) to always apply the filter.
  const getOffersConfig = useTouOffersConfig();

  const logic = useOfferStepLogic({
    getOffersConfig,
    buildSubmitPayload: ({ selectedDiscountCode, flowContext, offer }) => {
      const selectedOffer = getOffer({ ...flowContext, discountCode: selectedDiscountCode }, offer);

      return {
        offerType: selectedOffer?.discountType,
      };
    },
  });

  // exp-n-611 — default contract type. Acquisition offer step only (not the extension flow).
  // Delete this call (and the exp-n-611 folder) to remove the experiment.
  useDefaultContractTypePreSelection({
    isSuccessful: logic.isSuccessful,
    offers: logic.offers,
    selectedDiscountCode: logic.selectedDiscountCode,
    handleValueChange: logic.handleValueChange,
  });

  return (
    <TitleHeightSyncProvider>
      <RibbonHeightSyncProvider>
        <BaseOfferStep
          logic={logic}
          listItemsGap="3"
          renderOfferCard={offer => (
            <OfferCard
              key={offer.type}
              isOpen={logic.isPriceDetailsOpen}
              setOpen={logic.setIsPriceDetailsOpen}
              isSelected={offer.type === logic.selectedDiscountCode}
              onSelect={() => {
                if (!offer.type) return;
                logic.setValue('discountCode', offer.type, { shouldValidate: true, shouldDirty: true });
              }}
              offer={offer}
              textualData={logic.textualData}
              flowContext={logic.flowContext}
              energyType={logic.energyType}
            />
          )}
        />
      </RibbonHeightSyncProvider>
    </TitleHeightSyncProvider>
  );
};
